import type { AppCountry, FallbacksSchema, AppLanguage, PerCountryLanguageMap } from '@atlas/shared/universal/i18n';
import { BaseTranslationsLoader } from '@atlas/shared/universal/i18n';
import * as fr_FR from '@atlas/shared/universal/i18n/fallbacks/fr/fr-FR/chatbot.json' assert { type: 'json' };

export type ChatbotTranslationsKeys = { chatbot: typeof fr_FR };

export class ChatbotTranslationsLoader extends BaseTranslationsLoader<FallbacksSchema<ChatbotTranslationsKeys>> {
    constructor(apiUrl: string, country: AppCountry, language: AppLanguage) {
        super({
            apiConfig: { baseURL: apiUrl, headers: { 'x-country': country, 'x-user-language': language } },
            scopes: ['UxengChatbot'],
            country,
            language
        });
    }
    protected override getFallbackTranslationsMaps(): PerCountryLanguageMap<
        () => Promise<FallbacksSchema<ChatbotTranslationsKeys>>
    > {
        return {
            be: {
                'fr-BE': async () => {
                    throw Error('Not available yet');
                },
                'nl-BE': async () => {
                    throw Error('Not available yet');
                }
            },
            ch: {
                'de-CH': async () => {
                    throw Error('Not available yet');
                },
                'en-CH': async () => {
                    throw Error('Not available yet');
                },
                'it-CH': async () => {
                    throw Error('Not available yet');
                },
                'fr-CH': async () => {
                    throw Error('Not available yet');
                }
            },
            com: {
                'de-DE': async () => {
                    throw Error('Not available yet');
                },
                'en-GB': async () => {
                    throw Error('Not available yet');
                },
                'fr-FR': async () => {
                    throw Error('Not available yet');
                }
            },
            de: {
                'de-DE': async () => {
                    throw Error('Not available yet');
                }
            },
            es: {
                'es-ES': async () => ({
                    chatbot: (await import('@atlas/shared/universal/i18n/fallbacks/es/es-ES/chatbot.json')).default
                })
            },
            fr: {
                'fr-FR': async () => ({
                    chatbot: (await import('@atlas/shared/universal/i18n/fallbacks/fr/fr-FR/chatbot.json')).default
                })
            },
            it: {
                'it-IT': async () => {
                    throw Error('Not available yet');
                }
            },
            lu: {
                'fr-BE': async () => {
                    throw Error('Not available yet');
                }
            },
            nl: {
                'nl-NL': async () => {
                    throw Error('Not available yet');
                }
            },
            pt: {
                'pt-PT': async () => ({
                    chatbot: (await import('@atlas/shared/universal/i18n/fallbacks/pt/pt-PT/chatbot.json')).default
                })
            },
            uk: {
                'en-GB': async () => {
                    throw Error('Not available yet');
                }
            }
        };
    }
}
